import Swiper from "swiper";

export const SwiperArquitetos = () => {

	const sliders = document.querySelectorAll(".swiper-arquitetos");
	// let i = 0;

	sliders.forEach((slider) => {

		const swiper = new Swiper(slider, {
			slidesPerView: 4,
			spaceBetween: 64,
		});

		// swiper.slideNext();

		// const prevBtn = document.getElementById("swiper-rooms-prev-" + i);
		// const nextBtn = document.getElementById("swiper-rooms-next-" + i);

		// // Add disabled ao btn quando preciso
		// const updateNavButtons = () => {
		// 	if (swiper.isBeginning) {
		// 		prevBtn.disabled = true;
		// 	} else {
		// 		prevBtn.disabled = false;
		// 	}

		// 	if (swiper.isEnd) {
		// 		nextBtn.disabled = true;
		// 	} else {
		// 		nextBtn.disabled = false;
		// 	}
		// };

		// prevBtn.addEventListener("click", () => {
		// 	swiper.slidePrev();
		// 	updateNavButtons();
		// });

		// nextBtn.addEventListener("click", () => {
		// 	swiper.slideNext();
		// 	updateNavButtons();
		// });

		// updateNavButtons();

		// i++;
	});

};